import React from "react";
import TextField from "../TextField";

import { NumberFieldProps } from "./NumberField.types";
import useControlledState from "../hooks/useControlledState";

function NumberField(props: NumberFieldProps) {
  const {
    onChangeValue: onChangeValueProp,
    onChange,
    value: valueProp,
    ...other
  } = props;

  const [value, onChangeValue] = useControlledState(
    valueProp,
    onChangeValueProp
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
    if (onChangeValue) {
      const rawValue = event.target.value.trim();
      let convertedValue: number | null | string = null;
      if (rawValue === "") {
        convertedValue = null;
      } else if (isNaN(Number(rawValue)) || rawValue.endsWith(".")) {
        convertedValue = rawValue;
      } else {
        convertedValue = Number(rawValue);
      }
      onChangeValue(convertedValue);
    }
  };

  const textFieldValue = value ?? "";

  return (
    <TextField {...other} value={textFieldValue} onChange={handleChange} />
  );
}

export default NumberField;
